module.exports = __webpack_public_path__ + "static/media/  (10).b30ded0e.jpg";